export default __webpack_public_path__ + "static/media/banner.3759d8cd.png";